import { Component, OnInit } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { DeliveredToModel } from './deliveredTo.model'
import { DeliveredToService } from './deliveredTo.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { TransportModeService } from '../transportMode.master/transportMode.service'
import { TransportModeModel } from '../transportMode.master/transportMode.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-deliveredto.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './deliveredTo.master.component.html',
  styleUrl: './deliveredTo.master.component.css',
})
export class DeliveredToMasterComponent implements OnInit {
  deliveredtoColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'deliveryName',
      displayName: 'Delivered To Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'transportModeId',
      displayName: 'Transport Mode',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'dropdown',
      options: [],
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private deliveredtoService: DeliveredToService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  ngOnInit(): void {
    this.loadTransportModes()
  }

  loadTransportModes(): void {
    this.deliveredtoColumns.find(
      (col) => col.key === 'transportModeId',
    )!.options = this.masterCommonService.packingTypesList.map(
      (mode: TransportModeModel) => {
        

        return {
          label: mode.transportMode,
          value: mode.id,
        }
      },
    )
  }

  openAddUpdateDeliveredToDialog(
    mode: string,
    deliveredto?: DeliveredToModel,
  ): void {
    const fields = this.deliveredtoColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: deliveredto || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateDeliveredTo(result)
        } else {
          this.addDeliveredTo(result)
        }
      }
    })
  }

  addDeliveredTo(deliveredto: any): void {
    this.deliveredtoService.addDeliveredTo(deliveredto).subscribe({
      next: () => {
        this.toastr.success('Delivered To Added Successfully!', 'Success')
        this.masterCommonService.getAllDeliveredTos()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateDeliveredTo(deliveredto: any): void {
    this.deliveredtoService.updateDeliveredTo(deliveredto).subscribe({
      next: () => {
        this.toastr.success('Delivered To Updated Successfully!', 'Success')
        this.masterCommonService.getAllDeliveredTos()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteDeliveredTo(deliveredto: DeliveredToModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this delivered to?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        deliveredto.isDeleted = true
        this.deliveredtoService.deleteDeliveredTo(deliveredto).subscribe({
          next: () => {
            this.masterCommonService.deliveredTosList = this.masterCommonService.deliveredTosList.filter(
              (p) => p.id !== deliveredto.id,
            )
            this.toastr.success('Delivered To Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
